// Меню страницы профиля
const profileMenu = () => {
  const profileMenuTitle = document.querySelector(".profileMenuTitle")
  const profileMenu = document.querySelector(".profileMenu")
  if (profileMenu) {
    profileMenuTitle.addEventListener("click", function() {
      if (!this.classList.contains("profileMenuTitleActive")) {
        this.classList.add("profileMenuTitleActive")
        profileMenu.classList.add("profileMenuVisible")
      } else if (this.classList.contains("profileMenuTitleActive")) {
        this.classList.remove("profileMenuTitleActive")
        profileMenu.classList.remove("profileMenuVisible")
      }
    })
  }
}

export default profileMenu
